module.exports = __webpack_public_path__ + "static/media/sleeping-face.727281e1.png";